import { Users } from 'lucide-react';
import { ResponsiveImage } from './ResponsiveImage';

const moreTeamCard = {
  kind: 'more',
  name: 'Weitere Teammitglieder',
  role: 'im erweiterten EN:POWER Team',
};

const TeamCard = ({ member }) => {
  const isMoreCard = member.kind === 'more';

  return (
    <div className="overflow-hidden rounded-lg bg-slate-50 shadow-lg transition-shadow hover:shadow-xl md:rounded-2xl">
      <div className="aspect-[3/4] overflow-hidden">
        {isMoreCard ? (
          <div className="flex h-full w-full flex-col items-center justify-center bg-[#122A5C] px-6 text-center">
            <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20">
              <Users className="h-8 w-8 text-[#E07000]" />
            </div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/70">
              EN:POWER Team
            </span>
          </div>
        ) : member.image ? (
          <ResponsiveImage
            src={member.image}
            alt={member.name}
            width={member.imageWidth}
            height={member.imageHeight}
            sizes="256px"
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-[#122A5C]">
            <span className="text-5xl font-bold text-white">{member.initials}</span>
          </div>
        )}
      </div>
      <div className="p-5 text-center">
        <h3 className="font-heading text-lg font-bold text-[#122A5C]">{member.name}</h3>
        <p className="mt-1 text-sm font-semibold text-[#E07000]">{member.role}</p>
      </div>
    </div>
  );
};

export const TeamCarousel = ({ members }) => {
  const carouselItems = [...members, moreTeamCard];
  const repeatedItems = [...carouselItems, ...carouselItems, ...carouselItems];

  return (
    <div className="team-marquee-container overflow-hidden">
      <div
        className="team-marquee-content flex animate-team-scroll"
        style={{ '--team-card-count': carouselItems.length }}
      >
        {repeatedItems.map((member, index) => (
          <div
            key={`${member.name}-${index}`}
            className="mx-2 w-56 flex-shrink-0 md:mx-4 md:w-64"
            data-testid={`team-member-${index % carouselItems.length}`}
          >
            <TeamCard member={member} />
          </div>
        ))}
      </div>
    </div>
  );
};
